import { MessageDescriptor } from 'react-intl';

import { CBCT_Tooth_RootType } from '@/shared/api/protocol-ts/model/dto_report_common_pb';

import { rootTypeMessages } from '../config/i18n';

export const getRootTypeMessage = (
  rootType: CBCT_Tooth_RootType,
): MessageDescriptor => {
  if (rootType in rootTypeMessages) {
    return rootTypeMessages[rootType];
  }
  return rootTypeMessages[CBCT_Tooth_RootType.RootType_Unspecified];
};
